import SicCodesDownloader from "./SicCodesDownloader";
import TextNote from "components/common/TextNote";
import SicCodesDialog from "components/inputs/ingestion/SicCodes/SicCodesDialog";
import SICSummary from "components/inputs/sic/SICSummary";
import { useSelector } from "react-redux";

export const SICComponent = () => {
  const hazardProfile = useSelector(
    (state) => state?.input?.exposure?.hazardProfile ?? null
  );
  const hazardSummary = useSelector(
    (state) => state?.temp?.exposure?.hazardSummary ?? null
  );

  return (
    <>
      {(hazardProfile?.files ?? []).length > 0 && (
        <SICSummary hazardSummary={hazardSummary ?? null} />
      )}
      <SicCodesDialog />
      <SicCodesDownloader />
      <TextNote noteKey={"sicCodes"} title={"Notes"} />
    </>
  );
};

export default SICComponent;
